import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { colors } from '~/Config/Colors';
import { getColors } from '~/Redux/Modules/Colors';
import { useMountEffect } from '~/util';

import ListsInner from './ListsInner';

const Lists = () => {
  const defaultColors = ['white', ...colors];

  const dispatch = useDispatch();

  const customColors = useSelector(({ Colors }) => Colors.colors.map(color => color.hex));
  const isFetching = useSelector(({ Colors }) => Colors.isFetching);

  useMountEffect(() => {
    dispatch(getColors());
  });

  function getAvailableColors() {
    if (isFetching) {
      return;
    }

    return [...defaultColors, null, null, ...customColors];
  }

  return !isFetching && <ListsInner colors={getAvailableColors()} />;
};

export default Lists;
